// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import Modal from 'react-modal';
import AddSubscriptionPayPerGame from '../addSubsForPayPerGame';

const customStyles = {
  content : {
    top                   : '13%',
    left                  : '1%',
    right                 : '1%',
    bottom                : '1%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '15'
   }
};

class AddSubscription extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      customer_search_list: [],
      popUpVisible:false,
      sub_details: {
        mobile_no: '',
        name: '',
        venue: '',
        date: moment(),
        start_date: moment(),
        end_date: moment().add(1, 'month'),
        start_time: '',
        end_time: '',
        amount: 0,
        id: '',
        package:'',
        display_name:'',
        coupon:'',
        payment_mode:''
      },
      dialog_open_cust:false,
      cart:{},
      venues: [],
      game_types: [],
      packages: [],
      payment_modes: [],
      data_uploaded: false,
      data_error: false,
      search: false,
      post_cart_subscriptions: [],
      success_cart:{},
      child:false,
      value_set:false,
      // // TODO: remove after testing
      success_cart:{"id":"ccfc2aa2-4567-4165-a3d7-ccfdb2190251","extra_details":"","amount":2950.0,"state":"completed","items":[{"id":"88c38111-5e97-4810-a617-d47f3d54e7eb","extra_details":null,"object":{"subscription_id":"44b4a5d7-f91d-4226-83d6-207f2b4c57fb","homebatch_set":false,"type":"Package","name":"Football Improve - 8 Sessions Monthly","image":"game/footbal_adults.png"},"invoice_items":[{"amount":"2,500","description":"Football Improve - 8 Sessions Monthly","amount_type":"item_price"},{"amount":"450","description":"GST","amount_type":"tax"}]}],"summary":[{"value":"2,500","label":"Item total"},{"value":"450","label":"GST"},{"value":"2,950","label":"Order total"}],"coupon":{}},
      homebatches: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    // // TODO: remove after testing
    // this.setPostSubscriptions();
  }

  closeModal() {
      this.setState({popUpVisible: false});
    }

  openModal(){
      this.setState({popUpVisible:true});
    }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({ venues: data.venues, game_types: data.venues[0].game_types, payment_modes:data.payment_modes});
           // alert("fix");
           this.getPackageList();
       }).catch(error => error);
  }

  getPackageList() {
      let venue = this.state.sub_details.venue;
      let game_type = this.state.sub_details.game_type;
      if(!venue){venue=this.state.venues[0].id}
      if(!game_type){game_type=this.state.game_types[0].pk}
      var q_params = new URLSearchParams();
      q_params.append("venue", venue);
      q_params.append("game_type", game_type);
      // console.log(q_params);
     const url = `${getLocationOrigin()}/eagleeye/get_packages_for_subscription/?${q_params.toString()}`;
     const options = {...defaultOptions};
     // console.log(options);
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ packages: data.packages}))
       .catch(error => console.log(error));
  }

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_search_list: data.results, search: true}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  postAddSubscription(data, cart, props) {
    if(!data.venue){data.venue=this.state.venues[0].id}
    if(!data.game_type){data.game_type=this.state.game_types[0].pk}
    let found = ["items"].every(r=> Object.keys(cart).includes(r))
    if (found == false){
        alert("Cart is empty, please add atleast one package");
    } else{
        if (cart.items.length < 1){
          alert("Cart is empty, please add atleast one package");
        }
        else if( data.payment_mode == ''){
          alert("Please select payment mode");
        }
        else if (data.id != ""){
            var msg = `Are you sure?`;
            var result = confirm(msg);
            if (result == true){
                const url = `${getLocationOrigin()}/cart/process_cart/`;
                const options = {...defaultOptions};
                options['method'] = 'post';
                options['headers'] = {'content-type': 'application/json'}
                options['body'] = JSON.stringify({
                    'customer_id': data.id,
                    'payment_mode': data.payment_mode,
                });
                console.log('Going to fetch');
                return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then((response) => {
                    console.log(response)     
                    if(response.items[0].object.child){
                      alert("Subscription created!\n Please Set Homebatch of customer");
                      this.setState({child:true})
                    }
                    else{
                      alert("Subscription created!");
                    }
                    this.setState({success_cart: response},() => this.setPostSubscriptions());
                    // props.history.goBack();
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                });
            }
        }
        else {
            alert("Customer details missing");
        }
    }
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.sub_details);
    if (name=="display_name"){
        var temp_no = event.target.value.split(":");
        if (temp_no.length == 2){
             temp_no = temp_no.pop();
            if(temp_no.length != 10){
                new_selected_one[name] = temp_no;
                new_selected_one["mobile_no"] = "";
                new_selected_one["name"] = "";
                new_selected_one["id"] = "";
                this.setState({value_set:false})
            }
            else{
                new_selected_one[name] = event.target.value
            }
        }
        else{
            new_selected_one[name] = event.target.value
        }
    }
    else{
        new_selected_one[name] = event.target.value
    }
    this.setState({sub_details: new_selected_one}, () => {
        if (name=="venue" || name=="game_type"){
            var new_selected_one =  Object.assign({}, this.state.sub_details);
            new_selected_one["package"] = "";
            this.setState({sub_details: new_selected_one}, ()=>this.getPackageList());
        }
    });
  }

  handleVenueChange(event){
    const name = event.target.name
    const value = event.target.value
    const data = this.state.venues.find(each=> each.id == value)
    var new_value =  Object.assign({}, this.state.sub_details);
    new_value[name] = value
    new_value['game_type'] = data.game_types[0].pk
    this.setState({game_types:data.game_types, sub_details:new_value},()=>this.getPackageList())
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postAddSubscription(this.state.sub_details, this.state.cart, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleClose = () => {
    this.setState({dialog_open_cust:false})
  }

  handleOpen = () => {
    console.log('npmp')
    this.setState({dialog_open_cust:true});
  };

  searchCustomer() {
    {this.state.sub_details.display_name?this.getSearchList(this.state.sub_details.display_name):
      alert('Search cannot be blank')}
  }

  handleCustomerSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_name': this.state.sub_details.name,
                        'customer_mobile': this.state.sub_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.sub_details);
          cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
          this.setState({customer_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
    }

  setSearch(name, id, mobile){
    var new_selected_one =  Object.assign({}, this.state.sub_details);
    new_selected_one['mobile_no'] = mobile;
    new_selected_one['name'] = name;
    new_selected_one['id'] = id;
    new_selected_one['display_name'] = `${name}:${mobile}`;

    this.setState({sub_details: new_selected_one, search: false,value_set:true}, () =>{
        this.setCart(id);
    });
  }

  setCart(customer_id){
      var q_params = new URLSearchParams();
      q_params.append("customer_id", customer_id);
      const url = `${getLocationOrigin()}/cart/view/?${q_params.toString()}`;
      const options = {...defaultOptions};
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({cart: data}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
  }
  removeCartItem(customer_id, item_id){
      const url = `${getLocationOrigin()}/cart/remove_from_cart/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'customer_id': customer_id,
          'item_id': item_id,
      });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({cart: data}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
  }
  addCartItem(customer_id, package_id){
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      else if (package_id == ""){
          alert("Please select a package to add to cart");
      }
      else {
          const url = `${getLocationOrigin()}/cart/add_to_cart/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'package': package_id,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({cart: data}))
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
  }
  applyCoupon(coupon_code){
      var customer_id = this.state.sub_details.id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length < 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/apply_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              if (data.coupon.success != true){
                  temp['sub_details'] =  Object.assign({}, this.state.sub_details);
                  temp['sub_details']['coupon'] = "";
                  alert(data.coupon.message);
              }
              temp['cart'] = data;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
  }
  removeCoupon(coupon_code){
      var customer_id = this.state.sub_details.id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      else if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length > 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/remove_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              temp['sub_details'] =  Object.assign({}, this.state.sub_details);
              temp['sub_details']['coupon'] = "";
              temp['cart'] = data;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
  }

  handleDate(date, event, name){
    var new_selected_one =  {};
    new_selected_one[name] = date;
    this.setState(new_selected_one);
  }

  getSubscriptionData(subscription_id, index) {
     const url = `${getLocationOrigin()}/subscription/${subscription_id}/`;
     const options = {...defaultOptions};
     // console.log(options);
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           let new_selected_one = []
           new_selected_one =  this.state.post_cart_subscriptions.splice(0, this.state.post_cart_subscriptions.length);
           new_selected_one[index] = data;
           this.setState({ post_cart_subscriptions: new_selected_one});
           // console.log(data);
           var temp = {
               sessions: [],
               // day_of_week: "",
               // fixture: ""
           };
           let sessions_list = []
           for (var i = 0; i < data.package.sessions_per_week; i++){
               sessions_list.push({
                   fixture_list: []
               });
           }
           temp['sessions'] = sessions_list;
           var temp1 = {};
           temp1[`homebatches_${index}`] = temp;
           // console.log(temp1);
           this.setState(temp1,()=>{
               this.getHomebatchFixtureList( data.package.pk, 0, 0, 0);
           });
       })
       .catch(error => console.log(error));
  }

  setPostSubscriptions(){
      this.setState(
          { post_cart_subscriptions: new Array(this.state.success_cart.items.length).fill({})},
          () => {
              this.state.success_cart.items.forEach((item, index)=>{
                  if(item.object.homebatch_set == false && item.object.child){
                      this.getSubscriptionData(item.object.subscription_id, index);
                  }
              });
          }
      );
  }

  getHomebatchFixtureList( package_id, day_of_week, homebatch_index, session_index){
      var venue_id = this[`homebatchvenue_${homebatch_index}`].value;
      var q_params = new URLSearchParams();
      q_params.append("package_id", package_id);
      if(day_of_week == ""){
          q_params.append("day_of_week", 0);
      }
      else {
          q_params.append("day_of_week", day_of_week);
      }
      const url = `${getLocationOrigin()}/venue_list/${venue_id}/getfixtures/?${q_params.toString()}`;
      const options = {...defaultOptions};
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
             var temp = {};
             temp[`homebatches_${homebatch_index}`] = Object.assign({}, this.state[`homebatches_${homebatch_index}`]);
             temp[`homebatches_${homebatch_index}`]['sessions'][session_index]['fixture_list'] = data;
             this.setState(temp);
         })
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
  }
  setHomeBatch(subscription_id, homebatch_index){
      // alert(subscription_id);
      // alert(homebatch_index);
      var fixture_id_str = "";
      var key_list = [];
      Object.keys(this).forEach((key,index)=>{
           if(key.indexOf(`homebatches_${homebatch_index}_homebatchfixture_`) >= 0){
               key_list.push(key);
           }
      });
      key_list.sort();
      // alert(key_list);
      key_list.forEach((key,index)=>{
          if(fixture_id_str.split(",").some((elem,index)=>{return this[key].value==elem})){
              alert(`Slot '${index+1}' in Subscription '${homebatch_index+1}' has been repeated.\nPlease undo the same`)
          }
          else{
              if(this[key].value !=""){
                  if (fixture_id_str == ""){
                      fixture_id_str = this[key].value;
                  }
                  else {
                      fixture_id_str = [fixture_id_str, this[key].value].join(",");
                  }
              }
          }
      });
      if (fixture_id_str == ""){
          alert(`Please select timings for subscription ${homebatch_index+1}`);
      }
      else if (fixture_id_str.split(",").length != this.state.post_cart_subscriptions[homebatch_index].package.sessions_per_week){
          alert(`${this.state.post_cart_subscriptions[homebatch_index].package.sessions_per_week - fixture_id_str.split(",").length} more slots to be selected`);
      }
      else {
          var start_date = this.state[`startdate_${homebatch_index}`] ? this.state[`startdate_${homebatch_index}`].format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
          const url = `${getLocationOrigin()}/customer_list/save_home_batch/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'subscription_id': subscription_id,
              'fixture_ids': fixture_id_str,
              'start_date': start_date,
          });
         // console.log(options);
         // return 0;
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              // alert(fixture_id_str);
              if (data.success == true){
                  alert(`HomeBatch Set for subscription ${homebatch_index+1}`);
                  this.state.post_cart_subscriptions.splice(homebatch_index, 1);
                  var new_selected_one = this.state.post_cart_subscriptions.slice();
                  // new_selected_one[homebatch_index] = {};
                  this.setState({post_cart_subscriptions:new_selected_one},()=>{
                      // console.log(this.state.post_cart_subscriptions.length);
                      if(this.state.post_cart_subscriptions.length < 1){
                          this.props.history.goBack();
                      };
                  });
              }
              else{
                  alert(data.message);
              }
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });

      }
  }

  render() {
    console.log('####')
    console.log(this.state.dialog_open_cust)

    const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      
    return(

    <div style={{display:'flex',flexDirection:'column'}}>
      <div style={{float:'right'}}>
        <button className="btn" style={{border: 'none', backgroundColor: '#ece15a', margin: '5px',float:'right',width:'fit-content',padding:'5px'}} onClick={()=>this.openModal()}>
          <span style={{fontSize: '100%', margin: '4px', color: '#000'}}>Add Pay Per Game Subscription</span>
        </button>
      </div>

      <div style={{...styles.container}} className='col-md-12'>
      {/* <div className="container" style={{...styles.container, ...styles.work_in_progress}}>
          <div style={{
              position: "absolute",
              paddingTop: "25%",
              height: "100%",
              zIndex: "100",
              width: "100%",
              textAlign: "center",
              background: "#0f2c3ca3",
              color: "white",
              fontSize: "200%",
              fontWeight: "bold",
          }}>
              Work in Progress
          </div> */}

        {Object.keys(this.state.success_cart).length < 1 || !this.state.child ?
            <div className="row col-md-8 table-bordered" style={styles.table}>
              <div style={styles.main_header} className="col-md-12">
                <h3 style={{textAlign:'center'}}>Add Subscription</h3>
              </div>
              <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Customer
                  </div>
                  <div className="col-md-8 input-group" style={{width:'69%'}}>
                    <input type="text" name="display_name" className="form-control"
                      placeholder="Search for.. " value={this.state.sub_details.display_name}
                      data-customerId={this.state.sub_details.id}
                      onChange={this.handleChange} style={{ backgroundColor: this.state.value_set ? '#32B6A7': 'white'}}/>
                    <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.searchCustomer}></button>
                    </span>
                  </div>
                </div>
                {this.state.search?
                        <div className="col-md-12 btn-group" style={{width:'97%'}}>
                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                        style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                        :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                <div className="alert alert-danger">Search customer not found</div>
                <div>
                    <RaisedButton
                      onClick={this.handleOpen}
                      label="Add"
                      style={{float:'right'}}
                      secondary={true}
                    />
                    <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.dialog_open_cust}
                      onRequestClose={this.handleClose}
                    >
                      <div>
                          <div style={styles.main_header} className="col-md-12">
                              <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                            </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Name
                                  </div>
                                  <input type="text" style={styles.input} name="name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                  </div>
                                <input type="number" style={styles.input} name="mobile_no" className="required"
                                  value={this.state.sub_details.mobile_no} onChange={this.handleChange}/>
                              </div>
                            </div>
                          </Dialog>
                        
                        </div>
                        </div>
                      }</div>:''}

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Customer's Cart
                  </div>
                  <div style={styles.cart} className="col-md-8">
                      {Object.keys(this.state.cart).length > 0 ?
                          this.state.cart.items ?
                              this.state.cart.items.map((item, index) => {
                                  return(
                                      <div style={styles.cart_item_container}  key={index}>
                                        <div  style={{display:'flex',flexDirection:'row',width:'100%'}}>
                                          <div style={styles.cart_item_image} >
                                              <img src={
                                                  item.object.image ?
                                                  (item.object.image.indexOf("assets.sporthood.in") > 0 && item.object.image.indexOf("api.sporthood.in") > 0) ?
                                                  item.object.image :
                                                  `https://api.sporthood.in/media/${item.object.image}`
                                                  :
                                                  null
                                              }/>
                                          </div>
                                          
                                            <div style={styles.cart_item_title} className="col-md-2">
                                                {item.object.name}
                                            </div>
                                              {/* <div style={styles.cart_item_remove} className="col-md-8">
                                                  <i className="fa fa-trash"></i>
                                                  &nbsp;
                                                  Remove from cart
                                              </div> */}
                                            </div>
                                            <div style={{alignSelf:'center'}}>
                                            <button className="btn btn-sm" type="button" style={styles.cart_item_remove} onClick={() => this.removeCartItem(this.state.sub_details.id, item.id)}>
                                                <i className="fa fa-trash"></i>
                                                &nbsp;
                                                <span style={{width:'30%'}}>Remove from cart</span>
                                            </button>
                                            </div>

                                        

                                          <div style={styles.cart_item_price} className="col-md-4 pull-right">
                                              <div style={styles.cart_item_amount} className="col-md-12">
                                                  <i className="fa fa-rupee"></i> {item.invoice_items[0].amount}
                                              </div>
                                              <div style={styles.cart_item_tax} className="col-md-12">
                                                  {item.invoice_items[1].description}: <i className="fa fa-rupee"></i> {item.invoice_items[1].amount}
                                              </div>
                                          </div>
                                      </div>
                                  );
                              })
                          :
                          <div style={styles.cart_empty} className="col-md-12">
                              {/* --- Empty --- */}
                          </div>
                      :
                      <div style={styles.cart_empty} className="col-md-12">
                          {/* --- Empty --- */}
                      </div>
                      }
                  </div>
                </div>

                <div style={{...styles.items,"borderTop": "1px dashed","marginTop": "1em","paddingTop": "2.5em"}} className="col-md-12" >
                  <div style={styles.item_header} className="col-md-4">
                    Venue
                  </div>
                  <select name="venue" className="col-md-8" style={styles.item_body}  value={this.state.value}
                    onChange={this.handleVenueChange}>
                    {
                      this.state.venues.map((x, index) => (
                      <option key={x.id} value={x.id}>{x.name}</option>
                      ))
                    }
                  </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Game Type
                  </div>
                  <select name="game_type" className="col-md-8" style={styles.item_body} value={this.state.sub_details.game_type}
                    onChange={this.handleChange}>
                    {
                      this.state.game_types.map((x, index) => (
                      <option key={x.pk} value={x.pk}>{`${x.game} ${x.name}`}</option>
                      ))
                    }
                  </select>
                </div>

                <div style={{'padding': '2%',"borderBottom": "1px dashed","marginBottom": "1em","paddingBottom": "3.5em"}} className="col-md-12">
                  <div style={{display:'flex',flexDirection:'row'}}>
                    <div style={styles.item_header} className="col-md-4">
                      Package
                    </div>
                    <select name="package" className="col-md-8" style={{padding: '6px',width:'70%'}} value={this.state.value}
                      onChange={this.handleChange}>
                      <option key={1} value={""}>{`-------`}</option>
                      {
                        this.state.packages.map((x, index) => (
                        <option key={x.id} value={x.id}>{`${x.name} - Rs.${x.amount_including_gst}`}</option>
                        ))
                      }
                    </select>
                  </div>
                  <small style={styles.item_small} className="pull-right col-md-6">* prices are exclusive of tax</small>
                  <div style={{textAlign:"center"}} className="col-md-8 pull-right">
                      <button className="btn btn-sm col-md-8" type="button" style={{
                          backgroundColor:'#302C35',
                          backgroundColor:'#a94442',
                          marginTop: "1em",
                          color:'#ffffff',
                          float: "center",
                          fontWeight:"800",
                          marginBottom:'1%'
                      }} onClick={() => this.addCartItem(this.state.sub_details.id, this.state.sub_details.package)}>
                          Add Package to Cart
                      </button>
                  </div>
                </div>
                  
                

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Coupon Code
                  </div>
                  <div style={{display:'flex',flexDirection:'row',width:'69%'}}>
                    {
                        Object.keys(this.state.cart).length > 0 ?
                            this.state.cart.coupon ?
                                this.state.cart.coupon.code ?
                                    <div style={{width:'100%',display:'flex',flexDirection:'row'}}>
                                        <input type="text" style={{width:'80%'}} name="coupon"
                                        disabled={true}
                                        value={this.state.cart.coupon.code} onChange={this.handleChange}/>
                                        <button className="btn btn-sm pull-right" type="button" style={{backgroundColor:'#302C35',
                                        color:'#ffffff'}} onClick={() => this.removeCoupon(this.state.cart.coupon.code)}>
                                            Remove Coupon
                                        </button>
                                    </div>
                                    :
                                    <div style={{width:'100%',display:'flex',flexDirection:'row'}}>
                                        <input type="text" style={{width:'80%'}} name="coupon"
                                        // disabled={this.state.sub_details.coupon}
                                        value={this.state.sub_details.coupon} onChange={this.handleChange}/>
                                        <button className="btn btn-sm pull-right" type="button" style={{backgroundColor:'#302C35',
                                            color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.sub_details.coupon)}>
                                            Apply Coupon
                                        </button>
                                    </div>
                                :
                                <div style={{width:'100%',display:'flex',flexDirection:'row'}}>
                                    <input type="text" style={{width:'80%'}} name="coupon"
                                    // disabled={this.state.sub_details.coupon}
                                    value={this.state.sub_details.coupon} onChange={this.handleChange}/>
                                    <button className="btn btn-sm pull-right" type="button" style={{backgroundColor:'#302C35',
                                        color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.sub_details.coupon)}>
                                        Apply Coupon
                                    </button>
                                </div>
                            :
                            <div style={{width:'100%',display:'flex',flexDirection:'row'}}>
                                <input type="text" style={{width:'80%'}} name="coupon"
                                // disabled={this.state.sub_details.coupon}
                                value={this.state.sub_details.coupon} onChange={this.handleChange}/>
                                <button className="btn btn-sm pull-right" type="button" style={{backgroundColor:'#302C35',
                                    color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.sub_details.coupon)}>
                                    Apply Coupon
                                </button>
                            </div>
                    }
                  </div>

                </div>
                {Object.keys(this.state.cart).length > 0 ?
                    this.state.cart.summary ?
                        this.state.cart.summary.map((item, index) => {
                             return(
                                 <div style={styles.items} className="col-md-12" key={item.id}>
                                   <div style={styles.item_header} className="col-md-4">
                                     {item.label}
                                   </div>
                                   <div style={{...styles.item_header, textAlign: "right"}} className="col-md-4 pull-right">
                                       <i className="fa fa-rupee"></i> &nbsp;
                                       {item.value}
                                   </div>
                                 </div>
                             );
                         })
                         : null
                    :
                    null
                 }

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-4">
                     Payment Mode
                    </div>
                    <select name="payment_mode" className="col-md-8" style={styles.item_body} value={this.state.value}
                     onChange={this.handleChange}>
                     <option> --select-- </option>
                     {
                       Object.keys(this.state.payment_modes).map((key, index) => (
                       <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                       ))
                     }
                    </select>
                </div>

                <div style={styles.button_submit} className="col-md-12">
                  <input className="btn btn-lg" type="submit" value="Create Subscription" style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>
                </div>
              </form>
            </div>
        :
            <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} className="col-md-12">
                    <h3 style={{textAlign:'center'}}>Set details for New Subscription</h3>
                </div>
                <form  className="validated-form form-horizontal">

                    {this.state.post_cart_subscriptions.map((subscription, index)=>{
                        if (Object.keys(subscription).length > 1){
                            // if (this.state.homebatches[index])
                            var allowed_venue = subscription.edit_options.allowed_venues
                            var sessions_list = [];
                            if (Object.keys(this.state).indexOf(`homebatches_${index}`) > -1){
                                var sessions_list = this.state[`homebatches_${index}`].sessions;
                            }
                            // for (var i = 0; i < subscription.package.sessions_per_week; i++){
                            //     sessions_list.push(i);
                            // }
                            return(
                                <div key={subscription.id} style={{padding: '1%',width:'100%'}} className="col-md-12">
                                    <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '10%',paddingRight:'1%'}} className="col-md-12">
                                        Set Details: <br/>
                                        {subscription.__unicode__}, {subscription.package.sessions_per_week} sessions per week
                                    </div>

                                    {subscription.edit_options.start_date_editable == true ?
                                        <div>
                                            <div style={styles.item_header} className="col-md-12">
                                                &nbsp;
                                            </div>
                                            <div style={styles.items} className="col-md-12">
                                                <div style={styles.item_header} className="col-md-4">
                                                    Set Start Date:
                                                </div>
                                                <DatePicker name={`startdate_${index}`} dateFormat={'DD/MM/YYYY'} selected={this.state[`startdate_${index}`] || moment()} onChange={(date, e) => this.handleDate(date,e,`startdate_${index}`)}/>
                                            </div>
                                            <div style={styles.item_header} className="col-md-12">
                                                &nbsp;
                                            </div>
                                        </div>
                                    :
                                        <div style={styles.item_header} className="col-md-12">
                                            &nbsp;
                                        </div>
                                    }

                                    <div style={styles.item_header} className="col-md-12">
                                        Set Homebatch:
                                    </div>
                                    <div style={styles.items} className="col-md-12">
                                      <div style={styles.item_header} className="col-md-4">
                                        Venue
                                      </div>
                                      <select name="venue" className="col-md-8" style={styles.item_body}
                                          onChange={(e) => {
                                              sessions_list.forEach((session, index1)=>{
                                                  this.getHomebatchFixtureList(subscription.package.pk, this[`homebatchday_${index1}`].value, index, index1);
                                              });
                                            }}
                                          ref={(homebatchvenue) => { this[`homebatchvenue_${index}`] = homebatchvenue }}
                                          value={this.state.value}>
                                        {
                                          subscription.edit_options.allowed_venues.map((x, index) => (
                                              <option key={x.id} value={x.id}>{x.name}</option>
                                          ))
                                        }
                                      </select>
                                    </div>

                                    { sessions_list.map((session, index1) => {
                                        return(
                                            <div style={styles.items} className="col-md-12" key={index1}>
                                                <div style={styles.item_header} className="col-md-4">
                                                    Session {index1 +1}:
                                                </div>
                                                <div style={styles.items} className="col-md-12">
                                                    <div style={styles.item_header} className="col-md-4">
                                                        Day of week
                                                    </div>
                                                    <select name="day_of_week" className="col-md-8" style={styles.item_body}
                                                        ref={(homebatchday) => { this[`homebatches_${index}_homebatchday_${index1}`] = homebatchday }}
                                                        value={this.state.value}
                                                        onChange={(e) => this.getHomebatchFixtureList(subscription.package.pk, e.target.value, index, index1)}>
                                                        {
                                                            subscription.edit_options.allowed_venues[index].days.map((x, index) => (
                                                                <option key={x[0]} value={x[0]}>{`${x[1]}`}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                                <div style={styles.items} className="col-md-12">
                                                    <div style={styles.item_header} className="col-md-4">
                                                        Slot
                                                    </div>
                                                        <select name="fixture" className="col-md-8"
                                                            ref={(homebatchfixture) => { this[`homebatches_${index}_homebatchfixture_${index1}`] = homebatchfixture }}
                                                             style={{...styles.item_body,
                                                              MozWhiteSpace:"pre-wrap",
                                                              OWhiteSpace:"pre-wrap",
                                                              whiteSpace:"pre-wrap",
                                                              overflow: "hidden",
                                                              textOverflow:"ellipsis",
                                                              // borderBottom: "1px solid #DDD",
                                                              height: "4em",
                                                            }}
                                                        value={this.state.value}>
                                                        <option key={-1} value={""}>{"-----"}</option>
                                                        {
                                                            this.state[`homebatches_${index}`] ?
                                                                this.state[`homebatches_${index}`].sessions[index1].fixture_list.map((x, index) => (
                                                                    <option key={x.id}
                                                                        value={x.id}>
                                                                        {`${x.start_time} - ${x.name} -- ${x.game_level}, ${x.max_free_slots} slots free in batch`}
                                                                    </option>
                                                                ))
                                                                :
                                                                null
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="col-md-12" style={styles.button_submit}>
                                        <button className="btn btn-lg"
                                            style={{backgroundColor:'#302C35',color:'#ffffff'}}
                                            type="button" onClick={(e) => this.setHomeBatch(subscription.id, index)}>
                                            Set Homebatch
                                        </button>
                                    </div>

                                </div>
                            );
                        }
                    })}
                </form>
            </div>
        }
      </div>
      { this.state.popUpVisible ?
            <div >
             <Modal 
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                
                <AddSubscriptionPayPerGame />
                
              </Modal>
            </div>
            :
            ""
            
          }
    </div>
    );
  }
}

export default AddSubscription;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addSubscription/index.js